<div class="host-test-rule">
  <div class="tsr-container">
    <textarea 
      style="resize:none"
      nz-input
      [placeholder]="'robot.rule.modal.test.placeholder' | translate"
      [(ngModel)]="question"></textarea>
  </div>
  <div class="tsr-footer">
    <div class="left">
      <span *ngIf="intent">{{ "robot.rule.modal.test.intent" | translate }}{{ intent }}</span>
    </div>
    <div class="right">
      <button nz-button nzType="primary" (click)="testRule()">{{ "robot.rule.modal.test.btn_test" | translate }}</button>
    </div>
  </div>
</div>
